export default function auth({ next, Router }) {

  if (!localStorage.getItem('apiToken') || !localStorage.getItem('refreshToken')) {
    return Router.push('/logout');
  }

  return next();
}